import CourseCurriculumBlockPreview from "./CourseCurriculumBlockPreview";

export default CourseCurriculumBlockPreview;